import React from 'react';
import {Link} from 'react-router-dom'
import GoogleFontLoader from 'react-google-font-loader';

import Header from './Header'
import Navigation from './Nav'
import Footer from './Footer'



import './App.css';

import { Jumbotron, Container, Button, CardImg,Row, Col,
         Card, CardBody, CardTitle, CardSubtitle, 
         } from 'reactstrap';



function ScreenHome() {


    return (
        <div style={{backgroundColor:'#f5f5f5'}}>
            <Header />
            <Navigation/>

{/* GOOGLE FONTS -------------------------------------------------------------*/}       
        <GoogleFontLoader
            fonts={[
              {
                font: 'Roboto',
                weights: [400, '400i'],
              },
              {
                font: 'Roboto Condensed',
                weights: [400, 700],
              },
              {
                  font: 'Titillium Web',
                  weights: [400, 700],
                },
                {
                  font: 'Poppins',
                  weights: [400, 700],
                },
            ]}
            subsets={['cyrillic-ext', 'greek']}
             />
     
      
        <div>
        <Jumbotron fluid style={{
            animationName:'example', 
            animationDuration:'20s',
            backgroundColor: "#34b6bc",
            // backgroundImage:'linear-gradient(#e66465, #577fe3)',
            height:'150px',
            borderBottomLeftRadius:'60%',
            borderBottomRightRadius:'10%',
            paddingTop:'20px'
            
            }}>
       
  

{/* EN-TÊTE ---------------------------------------------------------- */}
     

        <Col className='text-center' style={{marginTop:'', marginRight:'40px'}}>

        <h1 style={{color:'#fede49', fontFamily:'Poppins', fontSize:'30px', fontWeight:'bold', marginBottom:'2px'}}>
            Développeur iOS & Web</h1>
        <p style={{color:'#fede49', fontFamily:'Poppins'}}>Swift, React Native, React, ExpressJS</p> 
        <p style={{color:'white', marginTop:'10px', fontFamily:'Poppins'}}>Bienvenue sur mon site! </p>
        </Col> 

  
        </Jumbotron>
        </div>

{/* PHYLOSOPHIE ---------------------------------------------------------- */}      
        <Container style={{marginTop:'60px', marginBottom:'40px'}}>

        <h1 style={{fontSize:'25px', color:'black'}}>- PHILOSOPHIE -</h1>

    <Col xs="12">
 
        <p style={{color:'black', marginTop:'20px', fontFamily:'Poppins'}}>
        <b>Curieuse et passionnée </b>de tout ce qui touche le numérique, 
            j'aime travailler sur des projets variés : développement d'applications mobiles iOS 
            avec <i>Swift</i>, multi-plateforme avec <i>React Native</i> et Web avec <i>React</i> et <i>expressJS</i>. Egalement passionnée par 
            la création de projets musicaux et d'architecture,
            je souhaite rejoindre une nouvelle équipe et ainsi mettre à profit cette polyvalence 
            issue d'un parcours professionnel riche en expériences.
        </p>
        <Button color="outline-info" name="formation" style={{
            width:'180px',
            borderColor:'#fc6234',
            borderWidth:'1px',
            color:'black',
            fontSize:'15px',
            borderRadius:'3.5rem / 100%',
            fontFamily:'Arial Narrow',
            letterSpacing:'0.2em',
            padding:'10px',
 
       }}><Link to="/formations" style={{fontFamily:'Poppins', color:'black'}}>Mon CV</Link></Button>
        </Col>
        <Col className='text-center' xs="12">
        <CardImg style={{width:"25%", borderRadius:'50%', marginTop:'20px'}} 
        src="/images/home/madamez.jpg" alt="Card image cap"/>
        </Col>

        </Container>

{/* RÉALISATIONS ---------------------------------------------------------- */}      
        <div>
        <Jumbotron fluid style={{
            backgroundColor: "white",
            paddingBottom:'Opx'
            }}>
       
        <Container>
        <Row>

        <Col className='text-center' style={{marginBottom:'40px'}}>

        {/* transform:'rotate(-3deg)' */}
        {/* fontFamily:'Brush Script MT' */}

        <h1 style={{fontSize:'25px', color:'black'}}>- DEVELOPPEMENT MOBILE & WEB-</h1>
        <p style={{color:'black', marginTop:'30px', fontFamily:'Poppins'}}>
            Retrouvez tous mes projets d'applications mobiles réalisés avec Swift 
            (iOS) et React Native (multi-plateforme), ainsi que mes projets web.</p>
        <Col>
        <p style={{marginBottom:'0px', fontSize:'13px', fontWeight:'bold', fontFamily:'Poppins'}}>Conception & architecture</p>
        <p style={{marginBottom:'0px', fontSize:'13px', fontWeight:'bold', fontFamily:'Poppins'}}>Intégration & responsive</p>
        <p style={{marginBottom:'0px', fontSize:'13px', fontWeight:'bold', fontFamily:'Poppins'}}>Reprise de projets existants</p>
        <p style={{marginBottom:'0px', fontSize:'13px',fontWeight:'bold', fontFamily:'Poppins'}}>Intégration des tests unitaires</p>
        <p style={{marginBottom:'20px', fontSize:'13px', fontWeight:'bold', fontFamily:'Poppins'}}>Utilisation de web service API</p>
        </Col>
        <Button color="outline-info" name="productions" style={{
            width:'180px',
            borderColor:'#fc6234',
            borderWidth:'1px',
            color:'black',
            fontSize:'15px',
            borderRadius:'3.5rem / 100%',
            fontFamily:'Arial Narrow',
            letterSpacing:'0.2em',
            padding:'10px',
 
       }}><Link to="/productions" style={{fontFamily:'Poppins', color:'black'}}>Mes applications</Link></Button>
       
        </Col>
        </Row>
        </Container>
        
        <Row>
        <Col className='text-center' >
        <CardImg style={{height:'80%', width:'50%'}} src="/images/home/iphone2.png" alt="Card image cap"/>
        </Col>
        </Row>
 
        </Jumbotron>
        </div>

        

        


{/* CRÉATIVITÉ ---------------------------------------------------------- */}
       <Container>
        <h1 style={{fontSize:'25px', color:'black'}}>- REALISATIONS ARTISTIQUES -</h1>
        <p style={{color:'black', marginTop:'20px', fontFamily:'Poppins'}}>     
        Avant de me lancer dans le développement mobile et web, j'ai longtemps travaillé dans les
         métiers de la musique et de l'architecture.
        Ce passé professionnel m'a ainsi permis de réaliser des concepts 
        et de collaborer étroitement en équipe.
        Si vous voulez en savoir un peu plus, je vous présente ici mes 
        réalisations musicales et architecturales.</p>
       

        <Row style={{marginTop:'20px'}}>

        {/* MUSIQUE ---------------------------------------------------------- */}  

        <Col className='text-center'> 
            <Card style={{backgroundColor:'white'}}>
            <CardTitle style={{fontFamily:'sans-serif', fontSize:'20px', paddingTop:'30px'}}>Créations sonores</CardTitle>
            <CardBody>
            <CardSubtitle style={{paddingBottom:'5px'}}>Savoir porter plusieurs casquettes</CardSubtitle>
            <Button color="outline-info" href="https://groovejourney.com/" name="groove journey"
            style={{
            width:'180px',
            borderColor:'#fc6234',
            borderWidth:'1px',
            color:'black',
            fontSize:'15px',
            borderRadius:'3.5rem / 100%',
            fontFamily:'Poppins',
            letterSpacing:'0.2em',
            padding:'10px',
 
       }}>En savoir plus</Button>
            <CardImg top height='80%' src="/images/home/son.jpg" alt="Card image cap" style={{paddingTop:'80px'}}/>

            </CardBody>
            </Card>
        </Col>  


        {/* IMAGE ---------------------------------------------------------- */}
        <Col className='text-center'>
        <Card style={{backgroundColor:'white'}}>
            <CardTitle style={{fontFamily:'sans-serif', fontSize:'20px', paddingTop:'30px'}}>Images</CardTitle>
            <CardBody>
            <CardSubtitle style={{paddingBottom:'5px'}}>Du concept à la réalisation</CardSubtitle>
            <Button color="outline-info" name="architecture"
            style={{
            width:'180px',
            borderColor:'#fc6234',
            borderWidth:'1px',
            color:'black',
            fontSize:'15px',
            borderRadius:'3.5rem / 100%',
            fontFamily:'Poppins',
            letterSpacing:'0.2em',
            padding:'10px',
 
       }}><Link to="/architecture" style={{fontFamily:'Poppins', color:'black'}}>En savoir plus</Link></Button>
            <CardImg top height="100%" src="/images/home/imagerie.jpg" alt="Card image cap" style={{paddingTop:'40px'}}/>

            </CardBody>
        </Card>
        </Col>
 
        </Row>
      
        </Container>

{/* CONTACT ---------------------------------------------------------- */}
        <div>
        <Jumbotron fluid style={{
            animationName:'example', 
            animationDuration:'20s',
            backgroundColor: "#34b6bc",
            // backgroundImage:'linear-gradient(#e66465, #577fe3)',
            height:'350px',
            marginTop:'50px',
            borderTopLeftRadius:'10%',
            borderTopRightRadius:'50%',
            
            }}>
       
       <Container>
        <Row>
        <Col style={{marginTop:'40px', marginLeft:'30px', marginRight:'40px'}}>
        <h1 style={{ fontSize:'25px', color:'#fede49'}}>Contactez-moi</h1>
        <p style={{color:'white', marginTop:'30px', textAlign:'center', fontFamily:'Poppins'}}>
            Si vous souhaitez obtenir des informations en plus, vous pouvez me contacter ici. </p>
        <Col className='text-center'>
        <Button color="outline-info" name="contact"
        style={{
            width:'180px',
            borderColor:'#fede49',
            borderWidth:'1px',
            color:'#fede49',
            fontSize:'15px',
            fontWeight:'bold',
            borderRadius:'3.5rem / 100%',
            fontFamily:'Arial Narrow',
            letterSpacing:'0.2em',
            padding:'10px',
 
       }}><Link to="/contact" style={{fontFamily:'Poppins', color:'#fede49'}}>Allons-y!</Link></Button>
        </Col> 
        </Col>
        </Row>
        </Container>
        </Jumbotron>
        </div>


{/* FOOTER ---------------------------------------------------------- */}     
        <Footer/>
        </div>
       

       
        
    );

}

export default ScreenHome;